/* Scent House — storefront enhancements (2026).
   1) Sold-out products always sit after in-stock products in every product grid.
   2) Free-shipping progress in the cart drawer and on the cart page.
   3) Sticky add-to-cart bar on product pages. */
(function () {
  'use strict';
  var SH = window.ScentHouse || {};
  var THRESHOLD = SH.freeShippingCents || 200000;
  var cart = SH.cart || { total: 0, count: 0 };

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var fmt = SH.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts[1] === '00' ? withCommas : withCommas + '.' + parts[1];
    });
  }

  /* ---------- 1) sold-out last ---------- */
  function isSoldOut(li) {
    return !!li.querySelector('.price--sold-out');
  }
  function partition(list) {
    var items = Array.prototype.slice.call(list.children);
    var sawSoldOut = false;
    var needs = false;
    for (var i = 0; i < items.length; i++) {
      var so = isSoldOut(items[i]);
      if (so) sawSoldOut = true;
      else if (sawSoldOut) { needs = true; break; }
    }
    if (!needs) return;
    items.filter(isSoldOut).forEach(function (li) { list.appendChild(li); });
  }
  function sortGrids() {
    if (SH.soldOutLast === false) return;
    document.querySelectorAll('ul.product-grid').forEach(partition);
  }

  /* ---------- 2) free shipping progress ---------- */
  function shipHTML() {
    var remaining = THRESHOLD - cart.total;
    var pct = Math.max(0, Math.min(100, Math.round((cart.total / THRESHOLD) * 100)));
    var done = remaining <= 0;
    var text = done
      ? (SH.strings && SH.strings.unlocked) || "You've unlocked <strong>FREE shipping</strong>"
      : ((SH.strings && SH.strings.away) || 'Add <strong>[amount]</strong> more to get <strong>FREE shipping</strong>')
          .replace('[amount]', formatMoney(remaining));
    var note = (SH.strings && SH.strings.note) || '';
    return '<div class="sh-ship' + (done ? ' sh-ship--done' : '') + '" role="status" data-key="' + cart.total + '-' + cart.count + '">' +
      '<p class="sh-ship__text">' + text + '</p>' +
      '<div class="sh-ship__track" aria-hidden="true"><div class="sh-ship__fill" style="width:' + pct + '%"></div></div>' +
      (note ? '<p class="sh-ship__note">' + note + '</p>' : '') +
      '</div>';
  }
  function bogoHTML() {
    var e = cart.eligible || 0;
    var b = SH.bogo || {};
    if (!e || !b.add) return '';
    if (e % 2 === 1) {
      return '<div class="sh-bogo"><p class="sh-bogo__text">' + b.add + '</p>' +
        (b.link && b.cta ? '<a class="sh-bogo__link" href="' + b.link + '">' + b.cta + '</a>' : '') + '</div>';
    }
    return '<div class="sh-bogo sh-bogo--done"><p class="sh-bogo__text">' + String(b.done || '').replace('[free]', e / 2) + '</p></div>';
  }
  function placeShip() {
    var targets = [
      document.querySelector('#CartDrawer .drawer__footer'),
      document.querySelector('#main-cart-footer .cart__blocks')
    ];
    var key = cart.total + '-' + cart.count + '-' + (cart.eligible || 0);
    targets.forEach(function (t) {
      if (!t) return;
      var existing = t.querySelector(':scope > .sh-cart-extras');
      if (cart.count === 0) { if (existing) existing.remove(); return; }
      if (existing && existing.getAttribute('data-key') === key) return;
      if (existing) existing.remove();
      t.insertAdjacentHTML('afterbegin', '<div class="sh-cart-extras" data-key="' + key + '">' + bogoHTML() + shipHTML() + '</div>');
    });
  }
  function refreshCart() {
    return fetch('/?section_id=sh-cart-data', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-sh-cart-data>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('no data');
        var c = JSON.parse(m[1]);
        cart = { total: c.total, count: c.count, eligible: c.eligible };
        placeShip();
      })
      .catch(function () {
        return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { cart = { total: c.total_price, count: c.item_count, eligible: cart.eligible }; placeShip(); })
          .catch(function () {});
      });
  }

  /* ---------- back in stock block ---------- */
  function initRestock() {
    var box = document.getElementById('ShRestock');
    if (!box) return;
    var mainBtn = document.querySelector('[id^="ProductSubmitButton-template--"][id$="__main"]');
    var anchor = mainBtn && (mainBtn.closest('product-form') || mainBtn.closest('form'));
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
    box.hidden = false;
  }

  /* ---------- 3) sticky add to cart ---------- */
  function initSticky() {
    var bar = document.getElementById('ShStickyAtc');
    if (!bar || !('IntersectionObserver' in window)) return;
    var mainBtn = document.querySelector('[id^="ProductSubmitButton-template--"][id$="__main"]');
    if (!mainBtn) return;
    var stickyBtn = bar.querySelector('[data-sh-sticky-btn]');
    var priceSlot = bar.querySelector('[data-sh-sticky-price]');

    function sync() {
      var price = document.querySelector('[id^="price-template--"][id$="__main"] .price');
      if (price) priceSlot.innerHTML = price.outerHTML;
      var label = mainBtn.querySelector('span');
      stickyBtn.textContent = (label ? label.textContent : mainBtn.textContent).trim();
      stickyBtn.disabled = mainBtn.disabled;
    }
    function show(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBtn.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('sh-has-sticky-atc', visible);
      if (visible) sync();
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(mainBtn);
    new MutationObserver(sync).observe(mainBtn, { attributes: true, childList: true, subtree: true });
    stickyBtn.addEventListener('click', function () {
      if (!mainBtn.disabled) mainBtn.click();
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    sortGrids();
    placeShip();
    initSticky();
    initRestock();

    // Re-apply after AJAX updates (filters/sorting, recommendations, cart drawer re-render).
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sortGrids();
        placeShip();
      });
    }).observe(document.body, { childList: true, subtree: true });

    /* global subscribe, PUB_SUB_EVENTS */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
